import React, { useRef } from "react";

import { UploadIcon } from "../../../../assets/icons";
import { UpdateLocalImagesInfoDTO } from "../../../../models/local/local.request";

interface PhotosInfoTabProps {
    value: UpdateLocalImagesInfoDTO;
    onChange: (value: UpdateLocalImagesInfoDTO) => void;
}

const PhotosInfoTab: React.FC<PhotosInfoTabProps> = ({ value, onChange }) => {

    const logoFileInputRef = useRef<HTMLInputElement>(null);
    const backgroundFileInputRef = useRef<HTMLInputElement>(null);

    const handleLogoUploadClick = () => {
        logoFileInputRef.current?.click();
    };

    const handleBackgroundUploadClick = () => {
        backgroundFileInputRef.current?.click();
    };

    const handleLogoFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.currentTarget.files?.[0];
        if (file) {
            onChange({ ...value, logoFileImage: file as any });
        }

    };

    const handleBackgroundFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.currentTarget.files?.[0];
        if (file) {
            onChange({ ...value, backgroundFileImage: file as any });
        }
    };



    return (
        <div className="photos-settings-block">
            <div className="admin-settings-box-div settings-logo-image">
                <div className="list-header-info">
                    <div className="list-header-title">Logo</div>
                    <div className="list-header-description">Logo se prikazuje u zaglavlju menija (preporučena veličina: 200x200px)</div>
                </div>
                <div className="info-settings-div">
                    <div className="w-form">
                        <form className="form-4">
                            <div className="div-block-6 photo-upload">

                                <div className="div-block-5">
                                    <label >Online logo (URL)</label>
                                    <input className="form-input basic-info w-input" placeholder="https://..." type="text"
                                        value={value.logoImageUrl}
                                        onChange={(e) => onChange({ ...value, logoImageUrl: e.target.value })}
                                    />
                                </div>

                                <div className="div-block-5">
                                    <label>Upload sa uredjaj</label>
                                    <div className="button-secondary upload" onClick={handleLogoUploadClick} style={{ cursor: 'pointer' }}>
                                        <img loading="lazy" src={UploadIcon} alt="" className="icon-size-24" />
                                    </div>
                                    <input
                                        ref={logoFileInputRef}
                                        type="file"
                                        style={{ display: 'none' }}
                                        onChange={handleLogoFileChange}
                                        accept="image/*"
                                    />
                                </div>

                            </div>
                        </form>
                    </div>
                    <div className="photos-logo-photo-div">
                        {value.logoFileImage ? (
                            <img loading="lazy" src={URL.createObjectURL(value.logoFileImage)} alt="" className="photos-logo-photo" />
                        ) : value.logoImageUrl ? (
                            <img loading="lazy" src={value.logoImageUrl + "@ul.webp"} alt="" className="photos-logo-photo" />
                        ) : (
                            <div style={{ padding: "20px" }}>No image</div>
                        )}
                    </div>
                </div>
            </div>
            <div className="admin-settings-box-div background">
                <div className="list-header-info">
                    <div className="list-header-title">Naslovna slika</div>
                    <div className="list-header-description">
                        Velika slika u zaglavlju menija (preporučena veličina: 1200x400px)<br />
                    </div>
                </div>
                <div className="info-settings-div">
                    <div className="w-form">
                        <form className="form-4">
                            <div className="div-block-6 photo-upload">

                                <div className="div-block-5">
                                    <label >Online pozadinska slika (URL)</label>
                                    <input className="form-input basic-info w-input" placeholder="https://..." type="text"
                                        value={value.backgroundImageUrl}
                                        onChange={(e) => onChange({ ...value, backgroundImageUrl: e.target.value })}
                                    />
                                </div>

                                <div className="div-block-5">
                                    <label >Upload sa uredjaj</label>
                                    <div className="button-secondary upload" onClick={handleBackgroundUploadClick} style={{ cursor: 'pointer' }}>
                                        <img loading="lazy" src={UploadIcon} alt="" className="icon-size-24" />
                                    </div>
                                    <input
                                        ref={backgroundFileInputRef}
                                        type="file"
                                        style={{ display: 'none' }}
                                        onChange={handleBackgroundFileChange}
                                        accept="image/*"
                                    />
                                </div>

                            </div>
                        </form>
                    </div>
                    <div className="photos-background-photo-div">
                        {value.backgroundFileImage ? (
                            <img loading="lazy" src={URL.createObjectURL(value.backgroundFileImage)} alt="" className="photos-background-photo" />
                        ) : value.backgroundImageUrl ? (
                            <img loading="lazy" src={value.backgroundImageUrl + "@ul.webp"} alt="" className="photos-background-photo" />
                        ) : (
                            <div style={{ padding: "20px" }}>No image</div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PhotosInfoTab;